<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">

  <div *ngIf="checkInWarningMessage" class="alert alert-warning text-center" role="alert">
    <b>Proficiency Check</b>: {{ checkInWarningMessage }}
    <span *ngFor="let proficiency of checkInWarningProficiencies"
          class="d-inline-block ml-2"
          [ngbTooltip]="proficiency.name"
          container="body">
      <app-proficiency-icon [colorHex]="proficiency.icon_color_hex"
                            [iconInitials]="proficiency.icon_initials">
      </app-proficiency-icon>
    </span>
  </div>

  <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger text-center" role="alert">
    {{ errorMessage }}
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <button class="btn btn-sm btn-outline-primary float-right ml-2"
                  style="font-size: 12px; line-height: 12px;"
                  [class.disabled]="loading()"
                  [disabled]="loading()"
                  (click)="checkInCustomerSharedPassInit()">
            {{ loading() ? 'Loading...' : 'Use Shared Pass' }}
          </button>
          <button class="btn btn-sm btn-outline-primary float-right ml-2"
                  style="font-size: 12px; line-height: 12px;"
                  [class.disabled]="loading()"
                  [disabled]="loading()"
                  (click)="checkInCustomerGuestPassInit()">
            {{ loading() ? 'Loading...' : 'Use Guest Pass' }}
          </button>
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  [class.disabled]="loading()"
                  [disabled]="loading()"
                  (click)="checkInCustomer(false, null)">
            {{ loading() ? 'Loading...' : 'Manual Check-In' }}
          </button>
          <span style="position: relative; top: 4px;">Check-In History</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col">Location</th>
        <th scope="col">Entry Method</th>
        <th scope="col">Milestones</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingCheckIns">
      <tr *ngFor="let checkIn of checkInsList.results"
          class="cursor-pointer"
          (click)="openCheckInDetailModal(checkIn)">
        <td class="text-nowrap">{{ dateStringFromISO8601(checkIn.check_in_datetime) }}</td>
        <td class="text-nowrap">{{ timeStringFromISO8601(checkIn.check_in_datetime) }}</td>
        <td>{{ checkIn.location_name }}</td>
        <td>
          {{ checkIn.entry_method_description }}
          <ng-container *ngIf="(checkIn.entry_method === CheckInEntryMethod.freeEntry) && checkIn.free_entry_reason">
            <br><br>
            <span class="text-muted">{{ checkIn.free_entry_reason }}</span>
          </ng-container>
        </td>
        <td>
          <span *ngFor="let milestone of checkIn.milestone_list"
                class="text-primary" style="display: block;line-height: 14px;">
            {{ milestone }}
          </span>
          <span *ngIf="checkIn.milestone_list.length === 0"
                class="text-secondary">
            --
          </span>
        </td>
        <td class="table-button-cell">
          <button class="btn btn-sm btn-outline-primary float-right"
                  style="font-size: 12px; line-height: 12px;"
                  (click)="openCheckInDetailModal(checkIn); $event.stopPropagation()">
            Details
          </button>
        </td>
      </tr>
      <tr *ngIf="checkInsList.results.length === 0">
        <td colspan="99" class="text-muted">No check-ins</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingCheckIns">
      <tr>
        <td colspan="99" class="text-muted">Loading check-ins...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeCustomerCheckInsSubList" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
